import script from "./navigationFooterUpper.vue?vue&type=script&setup=true&lang=js"
export * from "./navigationFooterUpper.vue?vue&type=script&setup=true&lang=js"

import "./navigationFooterUpper.vue?vue&type=style&index=0&id=61123e7c&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61123e7c"]])

export default __exports__